import React from 'react';
import ItemRow from './ItemRow';

const Section = ({ title, emptyText, items, count, t, locale, onOpen, onToggleDone, testId }) => (
  <section className="crs-section" data-testid={testId}>
    <p className="crs-section__label">
      {title}
      {count > 0 && <span className="crs-section__count">{count}</span>}
    </p>
    {items.length === 0 ? (
      <p className="crs-empty">{emptyText}</p>
    ) : (
      <div className="crs-list">
        {items.map((it) => (
          <ItemRow key={it.id} item={it} t={t} locale={locale} onOpen={onOpen} onToggleDone={onToggleDone} />
        ))}
      </div>
    )}
  </section>
);

// Calm attention: only Today (max 5) and Waiting For. Nothing more.
export default function OverviewSections({ overview, t, locale, onOpen, onToggleDone }) {
  if (!overview) return null;
  const today = (overview.today || []).slice(0, 5);
  const moreToday = (overview.today || []).length - today.length;
  return (
    <div className="crs-overview">
      <section className="crs-section" data-testid="creator-today-section">
        <p className="crs-section__label">
          {t.cr_today || 'Today'}
          {(overview.today || []).length > 0 && (
            <span className="crs-section__count">{(overview.today || []).length}</span>
          )}
        </p>
        {today.length === 0 ? (
          <p className="crs-empty">{t.cr_today_empty || 'Nothing needs you today.'}</p>
        ) : (
          <div className="crs-list">
            {today.map((it) => (
              <ItemRow key={it.id} item={it} t={t} locale={locale} onOpen={onOpen} onToggleDone={onToggleDone} />
            ))}
            {moreToday > 0 && (
              <p className="crs-empty" style={{ paddingTop: 8 }}>+ {moreToday}</p>
            )}
          </div>
        )}
      </section>
      <Section
        title={t.cr_waiting || 'Waiting for'}
        emptyText={t.cr_waiting_empty || 'Nothing is waiting on others.'}
        items={overview.waiting || []}
        count={(overview.waiting || []).length}
        t={t} locale={locale} onOpen={onOpen} onToggleDone={onToggleDone}
        testId="creator-waiting-section"
      />
    </div>
  );
}
